import { render, staticRenderFns } from "./progress-button.vue?vue&type=template&id=ebd0933c&scoped=true"
import script from "./progress-button.vue?vue&type=script&lang=js"
export * from "./progress-button.vue?vue&type=script&lang=js"
import style0 from "./progress-button.vue?vue&type=style&index=0&id=ebd0933c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd0933c",
  null
  
)

export default component.exports